export enum EmailVerificationResult {
  AlreadyVerified = 'ALREADY_VERIFIED',
  VerifiedFirstTime = 'VERIFIED_FIRST_TIME',
}
